import React, { useState, useEffect } from 'react';
import { getCachedTokenIcon, generateFallbackIcon } from '@/utils/tokenIcons';

interface TokenIconProps {
  symbol: string;
  size?: number;
  className?: string;
  alt?: string;
}

const TokenIcon: React.FC<TokenIconProps> = ({ 
  symbol, 
  size = 24, 
  className = '', 
  alt 
}) => {
  const [iconUrl, setIconUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadIcon = async () => {
      try {
        const url = await getCachedTokenIcon(symbol, size);
        setIconUrl(url);
      } catch (error) {
        console.warn(`Failed to load icon for ${symbol}:`, error);
        setIconUrl(generateFallbackIcon(symbol, size));
      } finally {
        setIsLoading(false);
      }
    };

    loadIcon();
  }, [symbol, size]);

  if (isLoading) {
    return (
      <div className={`animate-pulse bg-gray-300 rounded-full ${className}`} style={{ width: size, height: size }} />
    );
  }

  return (
    <img
      src={iconUrl}
      alt={alt || `${symbol} token`}
      className={`rounded-full bg-white ${className}`}
      style={{ width: size, height: size }}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.src = generateFallbackIcon(symbol, size);
      }}
    />
  );
};

export default TokenIcon;